import { GET_CONNECTED_USER_NOT_CONNECTED_ERROR } from "@/errors";
import { getConnectedUserError } from "@/store/actions";
import store from "@/store/configureStore";
import { sendDisconnectedNativeWebViewMessage } from "./native";

export const isUserConnected = () => {
    const token = localStorage.getItem("token");
    const expiration = new Date(localStorage.getItem("expiration"));
    const current_timestamp = new Date();

    return token && current_timestamp < expiration;
};

export const getAxiosTokenConfig = () => {
    const token = localStorage.getItem("token");
    return {
        headers: {'Authorization': "Token " + token}
    };
};

export const getActionPinConfig = (pin = "") => {
    const config = getAxiosTokenConfig();
    return {
        headers: {
            ...config.headers,
            "Barestho-Action-Pin": pin,
        }
    }
}

/**
 * This interceptor catches auth error from any request and reflects it by dispatching a connected user error to the global store.
 * @param {import("axios").AxiosError} error 
 * @returns 
 */
export function authErrorInterceptor(error) {
    const { status } = error.response ?? {};
    
    switch (status) {
        case 401:
            sendDisconnectedNativeWebViewMessage();
            store.dispatch(getConnectedUserError(GET_CONNECTED_USER_NOT_CONNECTED_ERROR));
            break;
        default:
            break;
    }

    return Promise.reject(error);
}

/**
 * This interceptor adds auth token config to any request headers.
 * @param {import("axios").AxiosRequestConfig} config 
 * @returns {import("axios").AxiosRequestConfig}
 */
export function authTokenHeaderInterceptor(config) {
    return {
        ...config,
        headers: {
            ...config.headers,
            ...getAxiosTokenConfig().headers,
        },
    };
}



// WEBPACK FOOTER //
// ./src/helpers/authentication.js